import PropTypes from "prop-types";
import Linkify from "linkify-react";
import TextLink from "@shared/v2/TextLink";
import { RotateRightSolidV6, UserPlusSolidV6 } from "@shared/v2/Icomoon";
import BaseEvent from "./BaseEvent";
import HomeInfoOverlay from "./HomeInfoOverlay";

const BUYSELL_REGEX = /sell|buy/;

const BrivityAdsEvent = ({ event, event: { timeline_fields: timelineFields = {} } }) => {
  const hasIntent = BUYSELL_REGEX.test(
    `${event.event_type}${timelineFields.utm_type}${timelineFields.utm_campaign}`,
  );
  const isBuyer = /buy/.test(`${event.event_type}${timelineFields.utm_type}${timelineFields.utm_campaign}`);
  return (
    <BaseEvent
      icon={event.new_lead ? <UserPlusSolidV6 /> : <RotateRightSolidV6 />}
      interactedAt={event.interacted_at_absolute}
      title={
        <div>
          {event.event_type === "ad_message" ? (
            "contact"
          ) : (
            <b>
              {`${timelineFields.f_name || timelineFields.first_name || ""} ${timelineFields.l_name || timelineFields.last_name || ""}`.trim() ||
                "No Name"}
            </b>
          )}
          {event.new_lead ? " came in" : " re-engaged"}
          {hasIntent ? ` as a ${isBuyer ? "buyer" : "seller"} lead ` : " "}from Brivity Connect
        </div>
      }
    >
      {timelineFields.property && <HomeInfoOverlay timelineFields={timelineFields.property} />}
      {timelineFields.message && (
        <div className="tw-whitespace-pre-wrap">
          Message: <br />
          {timelineFields.message.replace(/\\n/g, "\n")}
        </div>
      )}
      {timelineFields.utm_campaign && <div>Tags: {timelineFields.utm_campaign}</div>}
      {timelineFields.url && (
        <div>
          <TextLink href={timelineFields.url} target="_blank">
            View Search URL
          </TextLink>
        </div>
      )}
      {timelineFields.additional_information && (
        <div>
          <span>Additional Information: </span>
          <Linkify as="span" options={{ target: "_blank" }}>
            {timelineFields.additional_information.map?.((info) => info) ||
              timelineFields.additional_information}
          </Linkify>
        </div>
      )}
    </BaseEvent>
  );
};

BrivityAdsEvent.propTypes = {
  event: PropTypes.shape().isRequired,
};

export default BrivityAdsEvent;
